module.exports = __webpack_public_path__ + "img/fm-Path 42 Copy@3x.0dc34573.png";